import { ProductVersionStatus } from '../enums/product-version-status.enum';

export enum PrintingProductType {
    PrintedPart = 'Printed Part',
    Assembly = 'Assembly',
}

/** Stable identity; the editable definition lives on a version. */
export interface PrintingProduct {
    id: string;
    archived: boolean;
    createdById: string;
    createdOn: Date;
}

export interface PrintingProductVersion {
    id: string;
    productId: string;
    versionNumber: number;
    status: ProductVersionStatus;
    type: PrintingProductType;
    name: string;
    description: string;
    sourceVersionId: string;
    createdById: string;
    createdOn: Date;
    updatedById: string;
    updatedOn: Date;
    releasedById: string;
    releasedOn: Date | null;
    releaseComment: string;
}

/** Several versions may refer to the same immutable storage file. */
export interface PrintingProductFile {
    id: string;
    productId: string;
    productVersionId: string;
    fileId: string;
    fileName: string;
    mimeType: string;
    sizeBytes: number;
    createdById: string;
    createdOn: Date;
}

/** A BOM names an exact child revision, preserving released build definitions. */
export interface PrintingProductBomItem {
    id: string;
    parentVersionId: string;
    childProductId: string;
    childVersionId: string;
    quantity: number;
    sortOrder: number;
}
